import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { LanguageProvider } from './contexts/LanguageContext';
import { KosikProvider } from './contexts/KosikContext';
import PublicLayout from './components/PublicLayout';
import CookieConsent from './components/CookieConsent';
import HomePage from './components/HomePage';
import './App.css';

// Lazy loading pro méně kritické stránky
const ObjektyPage = lazy(() => import('./components/ObjektyPage'));
const KosikPage = lazy(() => import('./components/KosikPage'));
const Encyclopedia = lazy(() => import('./components/Encyclopedia'));

function App() {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

  return (
    <LanguageProvider>
      <KosikProvider>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
          <Router>
            <PublicLayout>
              <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Načítám...</div>}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/objekty" element={<ObjektyPage />} />
                  <Route path="/kosik" element={<KosikPage />} />
                  <Route path="/encyklopedie" element={<Encyclopedia />} />
                  <Route path="/encyklopedie/:page" element={<Encyclopedia />} />
                  <Route path="/encyklopedie/kamen/:stoneId" element={<Encyclopedia />} />
                </Routes>
              </Suspense>
            </PublicLayout>
            <CookieConsent />
          </Router>
        </GoogleReCaptchaProvider>
      </KosikProvider>
    </LanguageProvider>
  );
}

export default App;
